import { createSelector } from '@ngrx/store';
import { EStateStatus, IAppState } from '@app/app.state';
const selectAuthState = (state: IAppState) => state.auth;
export const selectAuth = createSelector(selectAuthState, (auth) => auth);
export const selectCurrentUser = createSelector(
  selectAuthState,
  (auth) => auth.currentUser,
);
export const selectIsAuthorized = createSelector(
  selectAuthState,
  (auth) => !!auth.currentUser,
);
export const selectIsAuthLoading = createSelector(
  selectAuthState,
  (auth) => auth.status === EStateStatus.LOADING,
);
export const selectFavoriteUrl = createSelector(
  selectAuthState,
  (auth) => auth.favoriteUrl,
);
